







import Vue from "vue"
import CProjectDetailPublicPage from "~/components/custom/projectDetail/CProjectDetailPublicPage.vue"
import { ProjectView } from "~/backendApis/viewModel"

interface DataType {
  project: ProjectView | null
}

export default Vue.extend({
  components: {
    CProjectDetailPublicPage,
  },
  layout: "application",
  validate({ params }) {
    return params.id !== undefined && /^[a-zA-Z0-9]+$/.test(params.id)
  },
  data(): DataType {
    return {
      project: null,
    }
  },
  async fetch() {
    this.project = await this.$clStores.projectSearchList.getters.getProjectByIdFromListOrRemote(
      this.$route.params.id
    )
  },
  head(): object {
    const appEnv = process.env.APP_ENV
    const backendFileAPIBaseURL = process.env.BACKEND_FILE_API_BASE_URL
    const meta = this.$clHelpers.metaTag.generate({
      title: this.project?.title || undefined,
      currentPath: this.$nuxt.$route.path,
      ogpImageUrl:
        appEnv === "production" // OGPは本番環境でのみ表示。ステージングはファイルAPI側がIP制限の関係でOGPの生成に対応していないため。
          ? `${backendFileAPIBaseURL}/project_ogp/${this.$route.params.id}`
          : undefined,
    })
    return {
      ...meta,
      ...(process.server
        ? {
            // SSRハイドレーションをスキップしてクライアントサイドレンダリングを強制する。
            // VueのJavaScriptが実行される前にdata-server-rendered属性を削除し、
            // Vueにハイドレーションではなく新規にDOMを構築させる。
            script: [
              {
                hid: "skip-hydration",
                innerHTML:
                  "(function(){var e=document.getElementById('__nuxt');if(e){e.removeAttribute('data-server-rendered');return}var o=new MutationObserver(function(){var e=document.getElementById('__nuxt');if(e){e.removeAttribute('data-server-rendered');o.disconnect()}});o.observe(document.documentElement,{childList:true,subtree:true});})();",
                type: "text/javascript",
              },
            ],
            __dangerouslyDisableSanitizersByTagID: {
              "skip-hydration": ["innerHTML"],
            },
          }
        : {}),
    }
  },
  watch: {
    "$fetchState.error"() {
      this.$nuxt.error({ statusCode: 404 })
    },
  },
  created() {
    this.$clStores.mobileNavigationMenu.actions.changeState({
      previousPagePath: "/projects",
      pageTitle: "プロジェクト",
    })
  },
  async mounted() {
    await this.$clStores.swCorporationAccount.actions.loadList()
  },
})
